export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    USER_BLACKLIST_ALL: function USER_BLACKLIST_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/user-blacklist/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    USER_BLACKLIST_CREATE: function USER_BLACKLIST_CREATE(data) {
      return request({
        url: '/api/user-blacklist/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    USER_BLACKLIST_DETAIL: function USER_BLACKLIST_DETAIL(id) {
      return request({
        url: '/api/user-blacklist/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    USER_BLACKLIST_UPDATE: function USER_BLACKLIST_UPDATE(data) {
      return request({
        url: '/api/user-blacklist/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    USER_BLACKLIST_DELETE: function USER_BLACKLIST_DELETE(id) {
      return request({
        url: '/api/user-blacklist/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    USER_BLACKLIST_SYNC: function USER_BLACKLIST_SYNC(data) {
      return request({
        url: '/api/user-blacklist/sync',
        method: 'post',
        data: data
      });
    }
  };
});